module.exports = __webpack_public_path__ + "img/icon-chuti-logo.a2f50fa3.png";